import React from 'react'

const LegalPage = ({ title }) => {
  // Контент для страницы "О продавце"
  if (title === 'О продавце') {
    return (
      <div style={{ padding: '80px 20px 40px', maxWidth: '800px', margin: '0 auto', width: '100%' }}>
        <h1 style={{ fontSize: '14px', fontWeight: '500', textTransform: 'uppercase', marginBottom: '32px', letterSpacing: '1px' }}>
          {title}
        </h1>
        <div style={{ fontSize: '12px', lineHeight: '1.8', color: '#333' }}>
          <div style={{ marginBottom: '24px' }}>
            <div style={{ fontWeight: '600', marginBottom: '8px', fontSize: '13px' }}>
              Индивидуальный предприниматель:
            </div>
            <div style={{ marginLeft: '16px' }}>
              <div style={{ marginBottom: '4px' }}>Желтышев Аким Сергеевич</div>
            </div>
          </div>

          <div style={{ marginBottom: '16px' }}>
            <div style={{ fontWeight: '600', marginBottom: '4px' }}>Юридический адрес:</div>
            <div style={{ marginLeft: '16px' }}>
              180000, Россия, Псковская область, г. Псков, пр-т Октябрьский, д. 12
            </div>
          </div>

          <div style={{ marginBottom: '16px' }}>
            <div style={{ fontWeight: '600', marginBottom: '4px' }}>ИНН:</div>
            <div style={{ marginLeft: '16px' }}>602712531629</div>
          </div>

          <div style={{ marginBottom: '16px' }}>
            <div style={{ fontWeight: '600', marginBottom: '4px' }}>ОГРНИП:</div>
            <div style={{ marginLeft: '16px' }}>325600000024780</div>
          </div>

          <div style={{ marginBottom: '16px' }}>
            <div style={{ fontWeight: '600', marginBottom: '4px' }}>Телефон для связи:</div>
            <div style={{ marginLeft: '16px' }}>
              <a href="tel:+79956260626" style={{ color: '#000', textDecoration: 'underline' }}>
                +7 995 626-06-26
              </a>
            </div>
          </div>

          <div style={{ marginBottom: '16px' }}>
            <div style={{ fontWeight: '600', marginBottom: '4px' }}>Telegram для связи:</div>
            <div style={{ marginLeft: '16px' }}>
              <a
                href="https://t.me/crysquad_store"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#000', textDecoration: 'underline' }}
              >
                @crysquad_store
              </a>
            </div>
          </div>

          <div style={{ marginBottom: '16px' }}>
            <div style={{ fontWeight: '600', marginBottom: '4px' }}>Электронная почта для связи:</div>
            <div style={{ marginLeft: '16px' }}>
              <a href="mailto:contact@crysquad.com" style={{ color: '#000', textDecoration: 'underline' }}>
                contact@crysquad.com
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // Контент для страницы "Условия"
  if (title === 'Условия') {
    return (
      <div style={{ padding: '80px 20px 40px', maxWidth: '800px', margin: '0 auto', width: '100%' }}>
        <h1 style={{ fontSize: '14px', fontWeight: '500', textTransform: 'uppercase', marginBottom: '32px', letterSpacing: '1px' }}>
          УСЛОВИЯ ИСПОЛЬЗОВАНИЯ САЙТА И ПРОДАЖИ ТОВАРОВ
        </h1>
        <div style={{ fontSize: '12px', lineHeight: '1.8', color: '#333' }}>

          <div style={{ marginBottom: '32px' }}>
            <h2 style={{ fontSize: '13px', fontWeight: '600', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              1. Общие положения
            </h2>
            <div style={{ marginLeft: '16px' }}>
              <p style={{ marginBottom: '12px' }}>
                <strong>1.1.</strong> Настоящие условия (далее — «Условия») регулируют отношения между Продавцом и любым лицом, использующим сайт crysquad.com (далее — «Покупатель»).
              </p>
              <p style={{ marginBottom: '12px' }}>
                <strong>1.2.</strong> Оформление заказа и/или оплата товара означает полное и безоговорочное согласие Покупателя с настоящими Условиями.
              </p>
              <p style={{ marginBottom: '12px' }}>
                <strong>1.3.</strong> Продавец вправе в любое время изменять настоящие Условия без предварительного уведомления. Актуальная версия Условий размещается на Сайте.
              </p>
            </div>
          </div>

          <div style={{ marginBottom: '32px' }}>
            <h2 style={{ fontSize: '13px', fontWeight: '600', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              2. Товары, представленные на Сайте
            </h2>
            <div style={{ marginLeft: '16px' }}>
              <p style={{ marginBottom: '12px' }}>
                <strong>2.1.</strong> Товары, представленные на Сайте, предлагаются к продаже на условиях, указанных на Сайте и в настоящих Условиях.
              </p>
              <p style={{ marginBottom: '12px' }}>
                <strong>2.2.</strong> Информация о товаре, включая наименование, описание, характеристики, комплектность, стоимость и иные сведения, размещается на Сайте.
              </p>
              <p style={{ marginBottom: '12px' }}>
                <strong>2.3.</strong> Продавец предоставляет информацию о товаре в объёме, предусмотренном законодательством Российской Федерации.
              </p>
            </div>
          </div>

          <div style={{ marginBottom: '32px' }}>
            <h2 style={{ fontSize: '13px', fontWeight: '600', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              3. Информация о товаре
            </h2>
            <div style={{ marginLeft: '16px' }}>
              <p style={{ marginBottom: '12px' }}>
                <strong>3.1.</strong> Описания, фотографии и иные материалы о товарах, размещённые на Сайте, носят информационный характер и предназначены для ознакомления Покупателя с основными свойствами товара.
              </p>
              <p style={{ marginBottom: '12px' }}>
                <strong>3.2.</strong> Продавец принимает разумные меры для обеспечения актуальности и достоверности информации о товарах, размещённой на Сайте.
              </p>
              <p style={{ marginBottom: '12px' }}>
                <strong>3.3.</strong> Незначительные отличия элементов оформления, оттенков, упаковки или деталей товара от изображений, представленных на Сайте, не являются недостатком товара, если такие отличия не влияют на его основные свойства и потребительские качества.
              </p>
              <p style={{ marginBottom: '12px' }}>
                <strong>3.4.</strong> В случае возникновения у Покупателя вопросов о свойствах, характеристиках, комплектности или иных параметрах товара, Покупатель вправе обратиться к Продавцу до оформления заказа.
              </p>
            </div>
          </div>

          <div style={{ marginBottom: '32px' }}>
            <h2 style={{ fontSize: '13px', fontWeight: '600', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              4. Цена и оплата
            </h2>
            <div style={{ marginLeft: '16px' }}>
              <p style={{ marginBottom: '12px' }}>
                <strong>4.1.</strong> Все цены указаны в рублях Российской Федерации.
              </p>
              <p style={{ marginBottom: '12px' }}>
                <strong>4.2.</strong> Продавец вправе изменять цены в одностороннем порядке до момента оформления заказа Покупателем.
              </p>
              <p style={{ marginBottom: '12px' }}>
                <strong>4.3.</strong> Обязательства Продавца по передаче товара возникают после подтверждения заказа и поступления полной оплаты, если иное не согласовано сторонами.
              </p>
            </div>
          </div>

          <div style={{ marginBottom: '32px' }}>
            <h2 style={{ fontSize: '13px', fontWeight: '600', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              5. Доставка
            </h2>
            <div style={{ marginLeft: '16px' }}>
              <p style={{ marginBottom: '12px' }}>
                <strong>5.1.</strong> Доставка осуществляется по территории Российской Федерации.
              </p>
              <p style={{ marginBottom: '12px' }}>
                <strong>5.2.</strong> Сроки и стоимость доставки определяются при оформлении заказа либо согласовываются с Покупателем отдельно.
              </p>
              <p style={{ marginBottom: '12px' }}>
                <strong>5.3.</strong> Риск случайной гибели или случайного повреждения товара переходит к Покупателю с момента передачи товара перевозчику либо Покупателю.
              </p>
              <p style={{ marginBottom: '12px' }}>
                <strong>5.4.</strong> Продавец не несёт ответственности за задержки доставки, возникшие по вине перевозчика или вследствие обстоятельств, не зависящих от Продавца.
              </p>
            </div>
          </div>

          <div style={{ marginBottom: '32px' }}>
            <h2 style={{ fontSize: '13px', fontWeight: '600', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              6. Возврат и отказ от товара
            </h2>
            <div style={{ marginLeft: '16px' }}>
              <p style={{ marginBottom: '12px' }}>
                <strong>6.1.</strong> Возврат товара осуществляется в соответствии с законодательством Российской Федерации.
              </p>
              <p style={{ marginBottom: '12px' }}>
                <strong>6.2.</strong> Порядок, сроки и условия возврата товара определяются в соответствии с требованиями законодательства Российской Федерации.
              </p>
              <p style={{ marginBottom: '12px' }}>
                <strong>6.3.</strong> Для оформления возврата Покупатель обязан обратиться к Продавцу способом, указанным на Сайте, и предоставить сведения о заказе.
              </p>
              <p style={{ marginBottom: '12px' }}>
                <strong>6.4.</strong> Денежные средства при наличии оснований для возврата перечисляются Покупателю после получения товара Продавцом и проверки соблюдения условий возврата.
              </p>
            </div>
          </div>

          <div style={{ marginBottom: '32px' }}>
            <h2 style={{ fontSize: '13px', fontWeight: '600', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              7. Ограничение ответственности
            </h2>
            <div style={{ marginLeft: '16px' }}>
              <p style={{ marginBottom: '12px' }}>
                <strong>7.1.</strong> Продавец не несёт ответственности за убытки, возникшие вследствие:
              </p>
              <ul style={{ marginLeft: '24px', marginBottom: '12px', listStyle: 'disc' }}>
                <li style={{ marginBottom: '6px' }}>нарушения Покупателем правил использования товара;</li>
                <li style={{ marginBottom: '6px' }}>предоставления Покупателем недостоверных данных при оформлении заказа;</li>
                <li style={{ marginBottom: '6px' }}>действий третьих лиц либо обстоятельств, не зависящих от Продавца.</li>
              </ul>
              <p style={{ marginBottom: '12px' }}>
                <strong>7.2.</strong> Ответственность Продавца в любом случае ограничивается стоимостью товара, оплаченной Покупателем, за исключением случаев, прямо предусмотренных законодательством Российской Федерации.
              </p>
            </div>
          </div>

          <div style={{ marginBottom: '32px' }}>
            <h2 style={{ fontSize: '13px', fontWeight: '600', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              8. Разрешение споров
            </h2>
            <div style={{ marginLeft: '16px' }}>
              <p style={{ marginBottom: '12px' }}>
                <strong>8.1.</strong> Все споры и разногласия, возникающие между сторонами, подлежат урегулированию путём переговоров и в досудебном порядке.
              </p>
              <p style={{ marginBottom: '12px' }}>
                <strong>8.2.</strong> При невозможности урегулирования спора в досудебном порядке спор рассматривается в судебном порядке в соответствии с законодательством Российской Федерации.
              </p>
            </div>
          </div>

        </div>
      </div>
    )
  }

  // Контент для страницы "Конфиденциальность"
  if (title === 'Конфиденциальность') {
    return (
      <div style={{ padding: '80px 20px 40px', maxWidth: '800px', margin: '0 auto', width: '100%' }}>
        <h1 style={{ fontSize: '14px', fontWeight: '500', textTransform: 'uppercase', marginBottom: '32px', letterSpacing: '1px' }}>
          ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ
        </h1>
        <div style={{ fontSize: '12px', lineHeight: '1.8', color: '#333' }}>
          
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{ fontSize: '13px', fontWeight: '600', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              1. Общие положения
            </h2>
            <div style={{ marginLeft: '16px' }}>
              <p style={{ marginBottom: '12px' }}>
                <strong>1.1.</strong> Настоящая Политика определяет порядок обработки персональных данных пользователей сайта crysquad.com.
              </p>
              <p style={{ marginBottom: '12px' }}>
                <strong>1.2.</strong> Обработка персональных данных осуществляется в соответствии с ФЗ №152-ФЗ «О персональных данных».
              </p>
            </div>
          </div>

          <div style={{ marginBottom: '32px' }}>
            <h2 style={{ fontSize: '13px', fontWeight: '600', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              2. Обрабатываемые данные
            </h2>
            <div style={{ marginLeft: '16px' }}>
              <p style={{ marginBottom: '12px' }}>
                Продавец обрабатывает следующие данные:
              </p>
              <ul style={{ marginLeft: '24px', marginBottom: '12px', listStyle: 'disc' }}>
                <li style={{ marginBottom: '6px' }}>имя и фамилия;</li>
                <li style={{ marginBottom: '6px' }}>номер телефона;</li>
                <li style={{ marginBottom: '6px' }}>адрес электронной почты;</li>
                <li style={{ marginBottom: '6px' }}>адрес доставки;</li>
                <li style={{ marginBottom: '6px' }}>IP-адрес, cookies, технические данные;</li>
                <li style={{ marginBottom: '6px' }}>платёжные данные (обрабатываются платёжными системами).</li>
              </ul>
            </div>
          </div>

          <div style={{ marginBottom: '32px' }}>
            <h2 style={{ fontSize: '13px', fontWeight: '600', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              3. Цели обработки
            </h2>
            <div style={{ marginLeft: '16px' }}>
              <p style={{ marginBottom: '12px' }}>
                Персональные данные используются исключительно для:
              </p>
              <ul style={{ marginLeft: '24px', marginBottom: '12px', listStyle: 'disc' }}>
                <li style={{ marginBottom: '6px' }}>оформления и исполнения заказов;</li>
                <li style={{ marginBottom: '6px' }}>связи с Покупателем;</li>
                <li style={{ marginBottom: '6px' }}>выполнения требований законодательства РФ.</li>
              </ul>
            </div>
          </div>

          <div style={{ marginBottom: '32px' }}>
            <h2 style={{ fontSize: '13px', fontWeight: '600', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              4. Передача данных
            </h2>
            <div style={{ marginLeft: '16px' }}>
              <p style={{ marginBottom: '12px' }}>
                <strong>4.1.</strong> Персональные данные могут передаваться:
              </p>
              <ul style={{ marginLeft: '24px', marginBottom: '12px', listStyle: 'disc' }}>
                <li style={{ marginBottom: '6px' }}>платёжным системам;</li>
                <li style={{ marginBottom: '6px' }}>службам доставки;</li>
                <li style={{ marginBottom: '6px' }}>государственным органам — в случаях, предусмотренных законом.</li>
              </ul>
              <p style={{ marginBottom: '12px' }}>
                <strong>4.2.</strong> Продавец не продаёт и не передаёт персональные данные третьим лицам в иных целях.
              </p>
            </div>
          </div>

          <div style={{ marginBottom: '32px' }}>
            <h2 style={{ fontSize: '13px', fontWeight: '600', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              5. Защита и хранение
            </h2>
            <div style={{ marginLeft: '16px' }}>
              <p style={{ marginBottom: '12px' }}>
                <strong>5.1.</strong> Продавец принимает разумные технические и организационные меры для защиты персональных данных.
              </p>
              <p style={{ marginBottom: '12px' }}>
                <strong>5.2.</strong> Данные хранятся не дольше, чем это необходимо для целей обработки и требований законодательства.
              </p>
            </div>
          </div>

          <div style={{ marginBottom: '32px' }}>
            <h2 style={{ fontSize: '13px', fontWeight: '600', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              6. Права пользователя
            </h2>
            <div style={{ marginLeft: '16px' }}>
              <p style={{ marginBottom: '12px' }}>
                Пользователь вправе:
              </p>
              <ul style={{ marginLeft: '24px', marginBottom: '12px', listStyle: 'disc' }}>
                <li style={{ marginBottom: '6px' }}>запросить информацию о своих персональных данных;</li>
                <li style={{ marginBottom: '6px' }}>потребовать их уточнения или удаления;</li>
                <li style={{ marginBottom: '6px' }}>отозвать согласие на обработку данных.</li>
              </ul>
            </div>
          </div>

        </div>
      </div>
    )
  }

  // Для других страниц
  return (
    <div style={{ padding: '80px 20px 40px', maxWidth: '800px', margin: '0 auto', width: '100%' }}>
      <h1 style={{ fontSize: '14px', fontWeight: '500', textTransform: 'uppercase', marginBottom: '24px' }}>{title}</h1>
      <p style={{ fontSize: '12px', lineHeight: '1.6' }}>
        Информация для страницы "{title}" будет добавлена позже.
      </p>
    </div>
  )
}

export default LegalPage

